import React, { useContext, useState } from 'react';
import { PrimaryButton } from '../../../components/common';
import AstuteService from '../../services/astute-service/astute-service';
import { useEmplifiFeedbackValueContent } from './hook/use-emplifi-feedback';
import './emplifi-feedback.scss';
import ErrorMessage from '../../../components/common/ErrorMessage/ErrorMessage';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import ServerContext from '../../../contexts/serverContext';

interface Props {
    topicId: number;
    sessionId: string;
}

const EmplifiFeedback = (props: Props) => {
    const emplifiFeedbackContent = useEmplifiFeedbackValueContent();
    const [sent, setSent] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [openFeedbackContainer, setOpenFeedbackContainer] = useState<boolean>(
        false
    );
    const [feedbackQuestions, setFeedbackQuestions] = useState<boolean>(true);
    const thumbsUpRating = 5;
    const thumbsDownRating = 1;
    const astuteService = new AstuteService();
    const serverContext = useContext(ServerContext);
    const sendfeedback = (rating: number) => {
        setLoading(true);

        const commentBox =
            (document.getElementById(
                'feedback-comment-box'
            ) as HTMLInputElement) || '';

        astuteService
            .sendRteArticleFeedback(
                props.sessionId,
                props.topicId,
                rating,
                commentBox.value || '',
                serverContext.currentLanguageRegionCode,
                serverContext.brand
            )
            .then(result => {
                setLoading(false);
                setError(false);
                setSent(result.success);
            })

            .catch(error => {
                setLoading(false);
                setError(true);
                console.error(error.message);
            });
    };

    const submitYesFeedback = () => {
        setFeedbackQuestions(false);
        sendfeedback(thumbsUpRating);
        setOpenFeedbackContainer(false);
    };

    const submitNoFeedback = () => {
        setFeedbackQuestions(false);
        setOpenFeedbackContainer(true);
    };

    return (
        emplifiFeedbackContent &&
        (sent ? (
            <div className="feedback-thank-you-note">
                {emplifiFeedbackContent?.thankYouLabel}
            </div>
        ) : (
            <div className="feedback-box">
                {feedbackQuestions && (
                    <>
                        <div className="feedback-title" tabIndex={0}>
                            {emplifiFeedbackContent?.feedbackTitle}
                        </div>
                        <div className="options">
                            <PrimaryButton
                                dataTestId={'submit-yes-button'}
                                onClick={submitYesFeedback}
                                fill={'fill'}
                                color={'dark'}
                                chevron={false}
                            >
                                {emplifiFeedbackContent?.yesButtonLabel}
                            </PrimaryButton>
                            <PrimaryButton
                                dataTestId={'submit-no-button'}
                                color={'dark'}
                                fill={'fill'}
                                chevron={false}
                                onClick={submitNoFeedback}
                            >
                                {emplifiFeedbackContent?.noButtonLabel}
                            </PrimaryButton>
                        </div>
                    </>
                )}
                {openFeedbackContainer && (
                    <div className="feedback-container-content">
                        <div className="feedback-container">
                            <div className="feedback-text-title">
                                {emplifiFeedbackContent?.feedbackTextTitle
                                    ? emplifiFeedbackContent?.feedbackTextTitle
                                    : emplifiFeedbackContent?.feedbackTitle}
                            </div>
                            <textarea
                                className="feedback-input"
                                id="feedback-comment-box"
                                aria-label={
                                    emplifiFeedbackContent?.commentBoxPlaceholder
                                }
                                aria-labelledby="disclaimer"
                                placeholder={
                                    emplifiFeedbackContent?.commentBoxPlaceholder
                                }
                            />
                        </div>
                        <div className="disclaimer" id="disclaimer">
                            {emplifiFeedbackContent.disclaimerLabel}
                        </div>
                        <div className="feedback-loading">
                            <PrimaryButton
                                className="text-button"
                                color="dark"
                                fill="fill"
                                chevron={false}
                                onClick={() => {
                                    sendfeedback(thumbsDownRating);
                                }}
                                dataTestId="send-feedback-button"
                            >
                                {emplifiFeedbackContent?.sendButtonLabel}
                            </PrimaryButton>
                            {loading && <ActivityIndicator radius="6" />}
                        </div>
                    </div>
                )}
                {error && emplifiFeedbackContent?.errorMessage && (
                    <ErrorMessage
                        error={emplifiFeedbackContent?.errorMessage}
                    />
                )}
            </div>
        ))
    );
};

export default EmplifiFeedback;
